

export default {
    id:"sendRequest",
    type:"(url:string,options?:object):Promise<Response>",
    options:[
        {
            name:"method",
            type:"string",
            defaultValue:"GET",
        },
        {
            name:"headers",
            type:"[string:any]",
        },
        {
            name:"body",
            type:"any",
        },
        {
            name:"searchParams",
            type:"[string:string]",
        },
        {
            name:"timeout",
            type:"number",
            defaultValue:"3000",
            description:"in milliseconds @0 to disable",
        },
        {
            name:"signal",
            type:"AbortSignal",
        },
        {
            name:"withCredentials",
            type:"boolean",
        },
    ],   
}
